<template>
  <CheckFormBox :title="$t('hzmbChange.title.lastest_drivers_data')">
    <div class="check_drivers" v-for="(item, index) in data" :key="index">
      <div class="check_drivers_title">{{ driversNum(index, false) }}</div>
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.driver_nameCn", [numLetter(index)]) }}：
          </div>
          <div class="form_value">{{ item.drvCname }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.driver_nameEn", [numLetter(index)]) }}：
          </div>
          <div class="form_value">{{ item.drvEname }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{
              isE02F02
                ? $t("hzmbChange.label.hk_drvIdentNo", [numLetter(index)])
                : $t("hzmbChange.label.driver_identityNo", [numLetter(index)])
            }}：
          </div>
          <div class="form_value">{{ item.drvIdentNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.driver_birthday", [numLetter(index)]) }}：
          </div>
          <div class="form_value">
            {{ item.drvBirthDate | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.driver_sex", [numLetter(index)]) }}：
          </div>
          <div class="form_value">
            {{
              item.drvGender && sex.length > 0
                ? sex.find((ele) => ele.codeKey == item.drvGender)[
                    $t("message.codeName")
                  ]
                : ""
            }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_nationality", [numLetter(index)])
            }}：
          </div>
          <div class="form_value">
            {{
              item.drvNational &&
              (item.drvNational === "XXX"
                ? item.otherNationalityText
                : nationality.length > 0
                ? nationality.find((ele) => ele.codeKey == item.drvNational)[
                    $t("message.codeName")
                  ]
                : "")
            }}
          </div>
        </el-col>
        <el-col  v-if="form.hzmbSubtype !== 'E02'" :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_macauDrivingLicenseType", [
                numLetter(index),
              ])
            }}：
          </div>
          <div class="form_value">
            {{
              item.drvLicTypeMo && drivingLicenseType.length > 0
                ? drivingLicenseType.find(
                    (ele) => ele.codeKey == item.drvLicTypeMo
                  )[$t("message.codeName")]
                : ""
            }}
          </div>
        </el-col>
        <el-col v-if="form.hzmbSubtype !== 'E02'" :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_macauDrivingLicenseNo", [
                numLetter(index),
              ])
            }}：
          </div>
          <div class="form_value">{{ item.drvLicNoMo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{
              isE02F02
                ? $t("hzmbChange.label.drvMobile", [numLetter(index)])
                : $t("hzmbChange.label.driver_macauMobile", [numLetter(index)])
            }}：
          </div>
          <div class="form_value">
            {{
              item.drvMobile
                ? item.mobileAreaCode
                  ? `+${item.mobileAreaCode}`
                  : "+853"
                : ""
            }}
            {{ item.drvMobile }}
          </div>
        </el-col>
        <el-col :span="24">
          <div class="form_label">
            {{
              isE02F02
                ? $t("hzmbChange.label.drvAddress", [numLetter(index)])
                : $t("hzmbChange.label.driver_macauAddress", [
                    numLetter(index),
                  ])
            }}：
          </div>
          <div class="form_value">
            {{ item.drvAddress1 }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_mainlandPhone", [numLetter(index)])
            }}：
          </div>
          <div class="form_value">
            {{ item.mainlandPhone ? "+86" : "" }} {{ item.mainlandPhone }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_mainlandEmail", [numLetter(index)])
            }}：
          </div>
          <div class="form_value">{{ item.mainlandEmail }}</div>
        </el-col>
        <el-col v-if="!isE02F02" :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_mainlandDrivingLicenseNo", [
                numLetter(index),
              ])
            }}：
          </div>
          <div class="form_value">{{ item.drvLicNoCn }}</div>
        </el-col>
        <el-col v-if="!isE02F02" :xs="24" :sm="12">
          <div class="form_label">
            {{
              $t("hzmbChange.label.driver_mainlandDrivingPermitNo", [
                numLetter(index),
              ])
            }}：
          </div>
          <div class="form_value">{{ item.drvCnFileNo }}</div>
        </el-col>
        <el-col v-if="isGHCompany" :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.drvLicNoHk", [numLetter(index)]) }}：
          </div>
          <div class="form_value">{{ item.drvLicNoHk }}</div>
        </el-col>
        <template v-if="isE02F02">
          <el-col :xs="24" :sm="12">
            <div class="form_label">
              {{ $t("hzmbChange.label.drvTempLicNoCn", [numLetter(index)]) }}：
            </div>
            <div class="form_value">{{ item.drvTempLicNoCn }}</div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="form_label">
              {{
                $t("hzmbChange.label.drvTempLicNoCnStartDate", [numLetter(index)])
              }}：
            </div>
            <div class="form_value">
              {{ item.drvTempLicNoCnStartDate | formatDT("dd/MM/yyyy") }}
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="form_label">
              {{
                $t("hzmbChange.label.drvTempLicNoCnStartDate", [numLetter(index)])
              }}：
            </div>
            <div class="form_value">
              {{ item.drvTempLicNoCnEndDate | formatDT("dd/MM/yyyy") }}
            </div>
          </el-col>
        </template>
      </el-row>
    </div>
  </CheckFormBox>
</template>

<script>
import VssViewAPI from "@/api/VssViewAPI";
import CheckFormBox from "@/view/DataRegistration/Check/components/CheckFormBox.vue";
export default {
  props: ["data", "form", "isE02F02", "isGHCompany"],
  components: { CheckFormBox },
  data() {
    return {
      sex: [],
      nationality: [],
      drivingLicenseType: [],
    };
  },
  computed: {
    driversNum() {
      return function (index, showDe = true) {
        if (showDe) {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver_de")
          );
        } else {
          return this.$t("hzmbChange.label.drivers_no", [
            this.$t(`message.capitalLetter[${index + 1}]`),
          ]);
        }
      };
    },
    lan() {
      return this.$i18n.locale;
    },
    numLetter() {
      return (index) => {
        return this.$t(`message.capitalLetter[${index + 1}]`);
      };
    },
  },
  async created() {
    // 基礎數據
    try {
      this.sex = await VssViewAPI.getsexs();
      this.nationality = await VssViewAPI.getNationalitys();
      this.drivingLicenseType = await VssViewAPI.getDrivingLicenseTypes();
    } catch (error) {
      this.$error(error);
    }
  },
};
</script>

<style lang="scss" scoped>
.check_drivers {
  padding-bottom: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(50, 50, 50, 0.16);
}
.check_drivers:last-child {
  padding-bottom: 0px;
  border-bottom: 0;
}
.check_drivers_title {
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
  line-height: 25px;
}
</style>
